<template>
  <div class="content-main">

    <van-popup v-model="loading" class="pop-loading">
      <div class="loading">
        <span>正在拼命加载中，请稍等片刻～</span>
        <van-loading type="spinner" />
      </div>
    </van-popup>

    <div class="shanzha" v-if="!submit_result">

      <div class="logo-and-wish flex-box">
        <img class="logo" :src="$store.state.favicon">
        <span>{{$store.state.siteSlogan}}</span>
      </div>

      <div class="message">

        <div class="info-input flex-box username">
          <div class="input-label">好友名字</div>
          <input class="username-content" placeholder="请填写好友名字或暗号" v-model="username" disabled />
        </div>

        <div class="info-input flex-box message-content">
          <div class="input-label">留言内容</div>
          <textarea class="message-text" rows="4" maxlength="200" placeholder="请填写留言内容" v-model="info"></textarea>
        </div>

        <div class="anony-and-count flex-box">
          <van-checkbox v-model="anonymous" label-position="left">不显示头像/昵称</van-checkbox>
          <span>字数：{{info.length}}/ 200</span>
        </div>

        <div class="btn-submit" @click="handleSubmit()">提交留言</div>

      </div>

    </div>

    <div class="page-success" v-if="submit_result">
      <img class="img-success" src="https://static.huiyiji520.com/submit-success-210916.png">
      <div class="hint hint1">留言提交成功！等待内容审核</div>
      <div class="hint hint2">预计{{getAuditTimeCost()}}小时内完成审核</div>
      <div class="hint hint2">审核时间为早9:00～晚18:00</div>
      <div class="hint hint2">审核通过以后，留言内容自动公开</div>
      <div class="btn-back" @click="goIndex()">返回首页</div>
    </div>

    <div class="btn-check flex-box" @click="goMessageCheck"><div class="btn-txt flex-box"><div>查看</div><div>留言</div></div></div>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Popup, Dialog } from 'vant'

export default{
  data(){
    return {
      info_id: this.$route.params.info_id,
      username: '',
      info: '',
      anonymous: false,
      submit_result: false,
      loading: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goUserCenter(){
      this.handleRouter('/user_center')
    },
    goMessageCheck(){
      this.$router.replace("/message_check")
    },
    goIndex(){
      this.$router.replace('/message_choose')
    },
    handleSubmit(){
      if(this.username.length == 0){
        Toast('请输入好友名字或暗号')
      }else if(this.info.length == 0){
        Toast('请输入留言内容')
      }else if(this.loading){
        return
      }else{
        this.loading = true
        let openid = this.$store.state.userinfo.openid
        this.$api.post('/garden/modify_msg', {id: this.info_id, openid: openid, watchword: this.username.trim(), msg: this.info.trim(), anonymous: this.anonymous}, res => {
          if(res.code == 200){
            this.loading = false
            this.submit_result = true
          }else if(res.code == 412){
            this.loading = false
            Toast(res.msg)
            // this.goMessageCheck()
          }
        })
      }
    },
    getAuditTimeCost(){
      let date = new Date()
      let hour = date.getHours()
      if(hour > 8 && hour < 18){
        return "12"
      }else{
        return "24"
      }
    },
    checkTimeForCreate(){
      let date = new Date()
      let hour = date.getHours()
      if(hour > 8 && hour < 24){
        return true
      }else{
        return false
      }
    },
    checkTimeDialog(){
      if(!this.checkTimeForCreate()){
        Dialog.alert({
          title: '提示',
          message: '修改留言时间为：早9点～晚24点\n其余时间仅可查看留言'
        }).then(() => {
          this.goMessageCheck()
        });
      }
    },
    getInfo(info_id){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/garden/get_msg_for_modify', {id: info_id, openid: openid}, res => {
        if(res.code == 200){
          this.username = res.username
          this.info = res.content
          this.anonymous = res.anonymous
        }else if(res.code == 412){
          Toast(res.msg)
          this.goMessageCheck()
        }
      })
    },
    wxConfigInit(){
      this.$api.get('/shanzhadao/get_wx_js_config_shanzhadao', {url: window.location.href}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
          });

          let share_nickname = this.$store.state.userinfo.nickname
          let share_title = `${share_nickname}给你写了一条留言～`
          let share_desc = '这里有你的故事'
          let share_link = this.$store.state.siteDomain
          let share_img = this.$store.state.userinfo.headimg

          let openid = this.$store.state.userinfo.openid
          let site_code = this.$store.state.siteCode
          let _this = this
          //分享到朋友圈（即将废弃）
          wx.onMenuShareTimeline({
            title: share_title, // 分享标题
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          //分享给朋友（即将废弃）
          wx.onMenuShareAppMessage({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          // //分享给朋友
          // wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
          //   wx.updateAppMessageShareData({
          //     title: share_title, // 分享标题
          //     desc: share_desc, // 分享描述
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });
          //
          // //分享到朋友圈
          // wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          //   wx.updateTimelineShareData({
          //     title: share_title, // 分享标题
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });

        }
      })
    }
  },
  mounted(){
    // this.checkTimeDialog()
    this.getInfo(this.info_id)
    this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{ min-height:100vh;background-color: #f8f8f8;color:#f1b8af;}
.shanzha{padding:15px;padding-top:25px;}
.logo-and-wish{font-size:17px;margin-bottom:20px;}
.logo{height:100px;width:100px;border-radius:100px;margin-right:25px;}
.message {background:#fff;padding:25px;}
.message .info-input{padding-bottom:15px;}
.message .username{border-bottom:1px solid #f1b8af;}
.message .input-label{font-size:14px;margin-right:20px;}
.username .username-content{font-size:13px;flex-grow:1;border:none;color:#333;background:#fff;}
.message .message-content{padding-top:15px;align-items:flex-start;}
.message-content .message-text{font-size:13px;flex-grow:1;border:none;color:#333;line-height:2.0;}
.anony-and-count{font-size:12px;justify-content:space-between;color:#969799;}
.btn-submit{background:#f1b8af;color:#fff;font-size:15px;font-weight:340;height:45px;line-height:45px;margin-top:20px;}
.btn-check{
  width:80px;height:80px;border-radius:80px;background:#f1b8af;position:fixed;
  bottom:40px;right:15px;color:#fff;justify-content:center;
}
.btn-txt{
  flex-direction: column;justify-content:center;border:1px solid #fff;width:66px;height:66px;
  border-radius:66px;border:1px solid #fff;font-size:15px;
}
*::-webkit-input-placeholder {color: #969799;font-size:12px;}
*:-moz-placeholder {/* FF 4-18 */color: #969799;font-size:12px;}
*::-moz-placeholder {/* FF 19+ */color: #969799;font-size:12px;}
*:-ms-input-placeholder {/* IE 10+ */color: #969799;font-size:12px;}
.page-success{padding-top:100px;}
.img-success{width:80px;height:80px;margin-bottom:30px;visibility:visible;}
.page-success .hint{margin-bottom:15px;font-size:17px;}
.page-success .hint1{color:#333;}
.page-success .hint2{color:#333;}
.page-success .hint3{color:#dd4b39;}
.notify-example{width:70%;}
@media (max-height: 500px) {
  .btn-check {
    display: none;
  }
}
.van-popup{width:70%;padding:20px;}
.pop-loading{
  background:rgba(255,255,255,0);
  color:#fff;
}
.content-main .loading .van-loading{
  margin:0 auto;
  margin-bottom:15px;
  margin-top:30px;
}
.content-main .loading{
  font-size:13px;
  padding:20;
}
.btn-back{
  background:#4caf50;color:#fff;font-size:15px;height:45px;line-height:45px;
  margin:0 auto;margin-top:30px;width:70%;border-radius:2px;
}
</style>
